// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PStopOutlinedSvg from "@fishx/icons-svg/es/asn/PStopOutlined";
import FishxIcon from '../components/FishxIcon';

var PStopOutlined = function PStopOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PStopOutlinedSvg
  }));
};

PStopOutlined.displayName = 'PStopOutlined';
export default React.forwardRef(PStopOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PStopOutlined.js
// module id = 3664
// module chunks = 0